<template>
  <div class="app_container">
    <div class="handle_wrapper">
      <butn
        v-permission="'classOffline:exportEnroll'"
        btntype="primary"
        title="导出"
        @click="exportExcel"
        :disabled="tableData && tableData.length === 0"
      />
      <drop-down
        v-if="selections.length === 0 && batchData.length > 0"
        class="dropdown dropdown-disable"
        title="批量操作"
        @select="handle"
      />
      <drop-down
        v-else-if="selections.length > 0 && batchData.length > 0"
        class="dropdown"
        title="批量操作"
        :data="batchData"
        @select="handle"
      />
    </div>
    <div class="search_right">
      <Search @search="search" />
    </div>
    <Table
      :data="tableData"
      @selectionChange="selectionChange"
      @del="del"
      @editMemberInfo="editMemberInfo"
      @goDetail="goDetail"
      @editMemberType="editMemberType"
    />
    <div class="RCPagination">
      <back-button v-if="$route.query.fromType" btnType="primary" :pathOptions="{path: '/centerSelectClass'}" />
      <back-button v-else btnType="primary" :pathOptions="{path: '/offlineClass'}" />
      <RCPagination
        ref="pagination"
        v-model="tableData"
        :api="api"
        :startRequest="false"
      />
    </div>
    <ChangeMemberType
      :dialogInfo="memberTypeDialogInfo"
      @close="closeMemberType"
      :memberTypeList="memberTypeList"
      v-if="memberTypeDialogInfo.show"
    />
    <UpdateMember
      :memberDialogInfo="memberDialogInfo"
      @closeEditMember="closeEditMember"
      v-if="memberDialogInfo.show"
    />
  </div>
</template>

<script>
import {
  tamePage,
  deleteStudent,
  graduation,
  cancelGraduation,
  setExcellent,
  cancelExcellent,
  updatePost,
  updateSuperior,
  updateTrainDays,
  exportEnroll,
} from "@/api/enrollOffline";
import Search from "./search";
import BackButton from "@/components/backButton/index.vue";
import RCPagination from "@/components/pagination/paginationManage";
import Table from "./table.js";
import butn from "@/components/button/index";
import store from "@/store";
import DropDown from "@/components/dropDown/index";
import ChangeMemberType from "@/views/offlineClass/transferStudents/sureMember/changeMemberType.vue";
import UpdateMember from "@/views/offlineClass/students/updateMember.vue";
import { getEnums, ioRead } from "@/utils/common.js";

export default {
  components: {
    butn,
    ChangeMemberType,
    DropDown,
    Search,
    Table,
    RCPagination,
    BackButton,
    UpdateMember,
  },
  data() {
    let batchData = [];
    // 针对上级路由onlineClass
    const permissionList = store.getters.permissionList["offlineClass"];
    if (
      permissionList &&
      permissionList.includes("classOffline:deleteStudent")
    ) {
      batchData.push({
        paramValue: "批量移除",
        paramKey: "1",
        way: "batchDelete",
      });
    }
    if (
      permissionList &&
      permissionList.includes("classOffline:updateSuperior")
    ) {
      batchData.push({
        paramValue: "批量修改人选类型",
        paramKey: "6",
        way: "batchChangeType",
      });
    }

    return {
      memberTypeList: [],
      memberDialogInfo: {
        show: false,
        member: {},
      },
      tableData: [],
      api: tamePage,
      selections: [],
      dataParams: {},
      batchData,
      isBatch: false,
      memberTypeDialogInfo: {
        superiorStatus: null,
        show: false,
      },
      nowRow: {},
      graduationStatusData: [],
    };
  },
  created() {
    this.classId = this.$route.query.id;
    getEnums(
      ["SUPERIOR_TRAIN_STATUS", "CLASS_FINISH_STATUS"],
      this,
      ["memberTypeList", "graduationStatusData"],
      [false, false]
    );
    this.$nextTick(() => {
      // this.search();
    });
  },
  methods: {
    goDetail(row) {
      const { userId: id } = row;
      this.$router.push({
        path: "/user/detail",
        query: { id, status: true },
      });
    },
    closeEditMember(flag) {
      if (flag) {
        this.search(this.dataParams);
      }
      this.memberDialogInfo.show = false;
    },
    editMemberInfo(row) {
      this.memberDialogInfo.member = row;
      this.memberDialogInfo.show = true;
    },
    async confirmWay(msg) {
      const flag = await this.$confirm(msg, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      return flag !== "confirm";
    },
    del(row) {
      this.dealWay(deleteStudent, "确认删除该学员吗？", [row.uuid]);
    },
    selectionChange(selections) {
      this.selections = selections;
    },
    childSearch() {
      this.search(this.dataParams);
    },
    search(params = {}) {
      this.dataParams = params;
      this.$refs["pagination"].reload({
        classId: this.$route.query.id,
        ...params,
        ...this.dataParams,
      });
    },
    exportExcel() {
      exportEnroll({
        ...this.dataParams,
        classId: this.$route.query.id,
      }).then((res) => ioRead(res));
    },
    handle(item) {
      this[item.way]();
    },
    dealSuccess(msg) {
      this.search(this.dataParams);
      this.$message({
        type: "success",
        message: msg,
      });
    },
    async dealWay(api, tip, uuids) {
      if (await this.confirmWay(tip)) return;
      api({ uuids }).then(({ code, msg }) => {
        if (code !== 0) return;
        this.dealSuccess(msg);
      });
    },
    batchDelete() {
      this.dealWay(
        deleteStudent,
        "确认批量移除选中的学员吗？",
        this.selections.map((x) => x.uuid)
      );
    },
    batchChangeType() {
      this.isBatch = true;
      this.memberTypeDialogInfo.superiorStatus = null;
      this.memberTypeDialogInfo.show = true;
    },
    editMemberType(row) {
      this.nowRow = row;
      this.isBatch = false;
      this.memberTypeDialogInfo.superiorStatus = row.superiorStatus || null;
      this.memberTypeDialogInfo.show = true;
    },
    closeMemberType(flag, superiorStatus) {
      if (flag) {
        updateSuperior({
          superiorStatus,
          enrollIds: this.isBatch
            ? this.selections.map((x) => x.uuid)
            : [this.nowRow.uuid],
        }).then(({ code, msg }) => {
          if (code !== 0) return;
          this.dealSuccess(msg);
          this.memberTypeDialogInfo.show = false;
        });
      } else {
        this.memberTypeDialogInfo.show = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.handle_wrapper {
  float: left;
}
</style>
